// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3I_A4","topBottomGutter":"Layout_topBottomGutter__3jgtu"};